import * as React from "react";
import ConnectedPageManagement from "src/page/containers/PageManagementContainer";

class App extends React.Component {
  public render() {
    return <ConnectedPageManagement />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/components/App.tsx